import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onUnmounted } from "vue";
import { useStore } from "@/store";


const __default__ = {
  name: "RedLight",
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { runnerOutputs, registerOutput, UnregisterOutput } = useStore();

const outputName = "red-light";
registerOutput(outputName);
onUnmounted(() => {
  UnregisterOutput(outputName);
});

const light = computed(() => runnerOutputs[outputName] === 1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      class: _normalizeClass(["light", { active: !_unref(light) }]),
      width: "70",
      src: "/runner/light-off.svg"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass(["light", { active: _unref(light) }]),
      width: "70",
      src: "/runner/light-on-red.svg"
    }, null, 2)
  ], 64))
}
}

})